export default {
  setMenu: (state, key = '') => {
    //Close menu if already open
    if(state.header.menu == key) {
      state.header.menu = '';
      return;
    }

    //Set key
    state.header.menu = key;
  },
  toggleMenu: (state, active=-1) => {
    state.header.menu_active = (active !== -1) ? active : !state.header.menu_active;
  },
  toggleSearch: (state, active=-1) => {
    state.header.search_active = (active !== -1) ? active : !state.header.search_active;
  },
  toggleCurrency: (state, active=-1) => {
    state.header.currency_active = (active !== -1) ? active : !state.header.currency_active;
    
  },

  showImage: (state, id) => {
    var image = _.find(state.header.images, (v) => {return v.key == id;});

    image.active = true;
  },

  hideImage: (state, id) => {
    var image = _.find(state.header.images, (v) => {return v.key == id;});

    image.active = false;
  },

  moveImage: (state, id, evt) => {
    var image = _.find(state.header.images, (v) => {return v.key == id;});

    //Find mouse pos
    var pos = window.app.utils.mouse.mousePositionElement(evt);

    image.x = pos.x;
    image.y = pos.y + 15;
  },
}